import {
  LIST_RESULT_CATEGORY_SUMMARY_REQUEST,
  LIST_RESULT_CATEGORY_SUMMARY_SUCCESS,
  LIST_RESULT_CATEGORY_SUMMARY_FAIL,
  LIST_RESULT_CATEGORY_SUMMARY_RESET,
  LIST_RESULT_CATEGORY_REQUEST,
  LIST_RESULT_CATEGORY_SUCCESS,
  LIST_RESULT_CATEGORY_FAIL,
  LIST_RESULT_CATEGORY_RESET,
  CREATE_RESULT_CATEGORY_REQUEST,
  CREATE_RESULT_CATEGORY_SUCCESS,
  CREATE_RESULT_CATEGORY_FAIL,
  DETAIL_RESULT_CATEGORY_REQUEST,
  DETAIL_RESULT_CATEGORY_SUCCESS,
  DETAIL_RESULT_CATEGORY_FAIL,
  UPDATE_RESULT_CATEGORY_REQUEST,
  UPDATE_RESULT_CATEGORY_SUCCESS,
  UPDATE_RESULT_CATEGORY_FAIL,
  DELETE_RESULT_CATEGORY_REQUEST,
  DELETE_RESULT_CATEGORY_SUCCESS,
  DELETE_RESULT_CATEGORY_FAIL
} from '../../constants/result-categories'

const initialState = {
  loading: false,
  resultCategories: [],
  resultCategory: {},
  resultCategoriesSummary: [],
  error: null,
  pageable: {}
}

const resultCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_RESULT_CATEGORY_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_RESULT_CATEGORY_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        resultCategoriesSummary: action.payload
      }
    case LIST_RESULT_CATEGORY_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_RESULT_CATEGORY_SUMMARY_RESET:
      return { ...state, loading: false, resultCategoriesSummary: [] }
    case LIST_RESULT_CATEGORY_REQUEST:
      return { ...state, loading: true }
    case LIST_RESULT_CATEGORY_SUCCESS:
      return { ...state, loading: false, resultCategories: action.payload, pageable: action.pageable }
    case LIST_RESULT_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_RESULT_CATEGORY_RESET:
      return { ...state, loading: false, resultCategories: [] }
    case CREATE_RESULT_CATEGORY_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_RESULT_CATEGORY_SUCCESS:
      return { ...state, loadingCreate: false, resultCategories: [...state.resultCategories, action.payload] }
    case CREATE_RESULT_CATEGORY_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_RESULT_CATEGORY_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_RESULT_CATEGORY_SUCCESS:
      return { ...state, loadingDetail: false, resultCategory: action?.payload }
    case DETAIL_RESULT_CATEGORY_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_RESULT_CATEGORY_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_RESULT_CATEGORY_SUCCESS:
      const examinationPayload = action.payload
      const examinationIndex = state.resultCategories.findIndex(resultCategory => resultCategory.id === examinationPayload.id)

      const examinationsUpdate = [...state.resultCategories]
      examinationsUpdate[examinationIndex] = examinationPayload

      return { ...state, loadingUpdate: false, resultCategories: examinationsUpdate }
    case UPDATE_RESULT_CATEGORY_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_RESULT_CATEGORY_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_RESULT_CATEGORY_SUCCESS:
      const examinationId = action.payload

      const examinationIndexDelete = state.resultCategories.findIndex(resultCategory => resultCategory.id === examinationId)
      const examinationsDelete = [...state.resultCategories]

      examinationsDelete.splice(examinationIndexDelete, 1)

      return { ...state, loadingDelete: false, resultCategories: examinationsDelete }
    case DELETE_RESULT_CATEGORY_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    default:
      return state
  }
}

export default resultCategoryReducer